// extracted by mini-css-extract-plugin
export default {"Bonuses":"Bonuses_Bonuses__3hL6U"};